import React, { useEffect } from 'react';
import { getFramework, useIdentity } from '@/framework';
import type { ContextMenuPlugin } from '@/plugins/context-menu';
import { PluginType, type IExportPlugin } from '@/version-types';
import { backgroundSplitItem } from './background-split-item';

const BackgroundLayerContentMenuView: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        framework.service.registration.getInstance<ContextMenuPlugin>('ContextMenuPlugin').addContextMenu([
            {
                key: 'backgroundSplit',
                group: 1,
                sort: 3,
                render: backgroundSplitItem,
            },
        ]);
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'background-layer-content-menu',
    render() {
        return <BackgroundLayerContentMenuView />;
    },
};

export default exportPlugin;
